<template>
  <div>
    <div class="mb-8" v-if="pack.price_print && pack.price_digital">
      <h3 class="mb-2 text-sm">Print or Digital Pack:</h3>
      <input type="radio" id="delivery_print" v-model="order.delivery_type_id" :value="0" />
      <label for="delivery_print" class="mr-12">Print Version</label>

      <input type="radio" id="delivery_digital" v-model="order.delivery_type_id" :value="1" />
      <label for="delivery_digital">Digital Version</label>
    </div>

    <div class="mb-8" v-if="propertySizePackItem">
      <h3 class="mb-2 text-sm">Property Size:</h3>
      <select v-model="propertySizeOrderItem.data.id" class="border hover:border-grey-darker p-3">
        <option v-for="(item, i) in propertySizePackItem.options" :key="i" :value="i">{{ item.name }} (+{{ item.price | gbp }})</option>
      </select>
      <small class="block mt-2" v-if="selectedOffice.network_id === 2 && focalAgentItems.length === 0">
        * Charge applies when you order a floorplan from Focal Agent.
      </small>
      <small class="block mt-2" v-if="selectedOffice.network_id === 7 && ehouseItems.length === 0">
        * Charge applies when you add your first item from eHouse.
      </small>
      <small class="block mt-2" v-else-if="selectedOffice.network_id === 7 && propertySizeOrderItem.data.id === propertySizePackItem.options.length - 1">
        * Subject to further uplift based on exact square footage
      </small>
    </div>

    <div v-if="professionalPhotoPackItem && agentPhotoPackItem" class="mb-8">
      <h3 class="mb-2 text-sm">Photos:</h3>
      <select v-model="photoOrderItem" class="border hover:border-grey-darker p-3">
        <option :value="professionalPhotoPackItem.id">
          Professional Photos
          {{ professionalPhotoPackItem.included_in_pack ? '(Included in Pack)' : '' }}
        </option>
        <option :value="agentPhotoPackItem.id">
          I will supply my own photos
          {{ agentPhotoPackItem.included_in_pack ? '(Included in Pack)' : (professionalPhotoPackItem.fulfillment_by === 2 ? `(-£${professionalPhotoPackItem.options.property_size_savings[propertySizeOrderItem.data.id]})` : '') }}
        </option>
      </select>
    </div>

    <div class="mb-8" v-if="floorplanUpgradeItem">
      <h3 class="mb-2 text-sm">Floorplan:</h3>
      <select v-model="upgradeFloorplanValue" class="border hover:border-grey-darker p-3">
        <option :value=false>Upload a Floorplan</option>
        <option :value=true>Order a Professional Floorplan (+{{ floorplanUpgradePrice | gbp }})</option>
      </select>
      <small class="block mt-2" v-if="selectedOffice.network_id === 7 && upgradeFloorplan && propertySizeOrderItem && propertySizeOrderItem.data.id === propertySizePackItem.options.length - 1">
        * Subject to further uplift based on exact square footage
      </small>
    </div>

    <div class="mb-8 flex">
      <div class="mr-12">
        <h3 class="mb-2 text-sm">EPC:</h3>
        <select v-model="epcOrderItem" class="border hover:border-grey-darker p-3">
          <option v-for="(option, i) in epcOptions" :key="i" :value="option.item_id">{{ option.name }}</option>
        </select>
      </div>

      <div v-if="epcAgentOrderItem" class="mr-12">
        <h3 class="mb-2 text-sm">EPC Rating:</h3>
        <select v-model="order.epc" class="border hover:border-grey-darker p-3">
            <option :value="null" disabled>Select a rating</option>
            <option value="A">EPC Rating A</option>
            <option value="B">EPC Rating B</option>
            <option value="C">EPC Rating C</option>
            <option value="D">EPC Rating D</option>
            <option value="E">EPC Rating E</option>
            <option value="F">EPC Rating F</option>
            <option value="G">EPC Rating G</option>
        </select>
      </div>
    </div>
    <div v-if="additionalEpcOrderItem" class="mb-8 flex">
      <div class="mr-12">
        <h3 class="mb-2 text-sm">Additional / Annexe EPC:</h3>
        <select v-model="additionalEpcOrderItem" class="border hover:border-grey-darker p-3">
          <option v-for="(option, i) in additionalEpcOptions" :key="i" :value="option.item_id">{{ option.name }}</option>
        </select>
      </div>
      <div v-if="additionalEpcAgentOrderItem" class="mr-12">
        <h3 class="mb-2 text-sm">EPC Rating:</h3>
        <select v-model="order.additional_epc" class="border hover:border-grey-darker p-3">
            <option :value="null" disabled>Select a rating</option>
            <option value="A">EPC Rating A</option>
            <option value="B">EPC Rating B</option>
            <option value="C">EPC Rating C</option>
            <option value="D">EPC Rating D</option>
            <option value="E">EPC Rating E</option>
            <option value="F">EPC Rating F</option>
            <option value="G">EPC Rating G</option>
        </select>
      </div>
    </div>
  </div>
</template>

<script>
import { find } from 'lodash'
import { mapState } from 'vuex'
export default {
  props: ['value', 'pack', 'ehouse-items', 'focal-agent-items', 'upgradeFloorplan'],
  data () {
    return {
      order: this.value
    }
  },
  computed: {
    ...mapState(['selectedOffice']),
    epcOptions () {
      const propertySizePrice = this.epcSupplierPackItem.options ? this.epcSupplierPackItem.options[this.propertySizeOrderItem.data.id].price : 0
      const basePrice = parseFloat(this.epcSupplierPackItem.pivot.price)

      return [
        {
          name: 'Not required for this property',
          item_id: null
        },
        {
          name: `Order a new EPC (+£${propertySizePrice + basePrice}.00)`,
          item_id: this.epcSupplierPackItem.id
        },
        {
          name: 'Upload an existing EPC',
          item_id: this.epcAgentPackItem.id
        }
      ]
    },
    additionalEpcOptions () {
      if (this.additionalEpcSupplierPackItem) {
        return [
          {
            name: 'Not required for this property',
            item_id: null
          },
          {
            name: `Order a new EPC (+£${this.additionalEpcSupplierPackItem.pivot.price})`,
            item_id: this.additionalEpcSupplierPackItem.id
          },
          {
            name: 'Upload an existing EPC',
            item_id: this.additionalEpcAgentPackItem.id
          }
        ]
      }

      return []
    },
    propertySizePackItem () {
      return find(this.pack.items, (item) => item.internal_type_id === 0)
    },
    propertySizeOrderItem () {
      return this.propertySizePackItem ? find(this.order.items, (item) => item.marketing_pack_item_id === this.propertySizePackItem.id) : null
    },
    professionalPhotoPackItem () {
      return find(this.pack.items, (item) => item.internal_type_id === 11 && item.fulfillment_by === 2)
    },
    agentPhotoPackItem () {
      return find(this.pack.items, (item) => item.internal_type_id === 11 && item.fulfillment_by === 0)
    },
    photoOrderItem: {
      get () {
        let item = find(this.order.items, (item) => [this.professionalPhotoPackItem.id, this.agentPhotoPackItem.id].includes(item.marketing_pack_item_id))
        return item ? item.marketing_pack_item_id : null
      },
      set (itemId) {
        let item = find(this.order.items, (item) => [this.professionalPhotoPackItem.id, this.agentPhotoPackItem.id].includes(item.marketing_pack_item_id))
        if (item) {
          this.order.items.splice(this.order.items.indexOf(item), 1)
        }

        if (itemId !== null) {
          this.order.items.push({
            marketing_pack_item_id: itemId,
            delivery_address_id: null,
            data: null
          })
        }
      }
    },
    floorplanIncludedItem () {
      return find(this.pack.items, (item) => item.internal_type_id === 19 && item.included_in_pack)
    },
    floorplanUpgradeItem () {
      return find(this.pack.items, (item) => item.internal_type_id === 19 && !item.included_in_pack)
    },
    upgradeFloorplanValue: {
      get () { return this.upgradeFloorplan },
      set (value) {
        this.$emit('changeUpgradeFloorplan', value)
      }
    },
    floorplanUpgradePrice () {
      // Focal Agent
      if (this.floorplanUpgradeItem && this.floorplanUpgradeItem.fulfillment_by === 7) {
        return parseFloat(this.floorplanUpgradeItem.pivot.price)
      }

      if (!this.propertySizeOrderItem || !this.floorplanUpgradeItem) {
        return 0
      }

      // Ehouse floorplan price is based on the property size
      return this.floorplanUpgradeItem.options[this.propertySizeOrderItem.data.id].price || 0
    },
    epcSupplierPackItem () {
      return find(this.pack.items, (item) => item.internal_type_id === 1 && [2, 7].includes(item.fulfillment_by))
    },
    epcAgentPackItem () {
      return find(this.pack.items, (item) => item.internal_type_id === 1 && item.fulfillment_by === 0)
    },
    epcAgentOrderItem () {
      if (!this.epcAgentPackItem) {
        return null
      }
      return find(this.order.items, (item) => item.marketing_pack_item_id === this.epcAgentPackItem.id)
    },
    additionalEpcAgentOrderItem () {
      if (!this.additionalEpcAgentPackItem) {
        return null
      }
      return find(this.order.items, (item) => item.marketing_pack_item_id === this.additionalEpcAgentPackItem.id)
    },
    epcOrderItem: {
      get () {
        let item = find(this.order.items, (item) => [this.epcSupplierPackItem.id, this.epcAgentPackItem.id].includes(item.marketing_pack_item_id))
        return item ? item.marketing_pack_item_id : null
      },
      set (itemId) {
        let item = find(this.order.items, (item) => [this.epcSupplierPackItem.id, this.epcAgentPackItem.id].includes(item.marketing_pack_item_id))
        if (item) {
          this.order.items.splice(this.order.items.indexOf(item), 1)
        }

        if (itemId !== null) {
          this.order.items.push({
            marketing_pack_item_id: itemId,
            delivery_address_id: null,
            data: null
          })
        }
      }
    },
    additionalEpcSupplierPackItem () {
      return find(this.pack.items, (item) => item.internal_type_id === 2 && item.fulfillment_by === 2)
    },
    additionalEpcAgentPackItem () {
      return find(this.pack.items, (item) => item.internal_type_id === 2 && item.fulfillment_by === 0)
    },
    additionalEpcOrderItem: {
      get () {
        let item = this.additionalEpcSupplierPackItem ? find(this.order.items, (item) => [this.additionalEpcSupplierPackItem.id, this.additionalEpcAgentPackItem.id].includes(item.marketing_pack_item_id)) : null
        return item ? item.marketing_pack_item_id : null
      },
      set (itemId) {
        let item = find(this.order.items, (item) => [this.additionalEpcSupplierPackItem.id, this.additionalEpcAgentPackItem.id].includes(item.marketing_pack_item_id))
        if (item) {
          this.order.items.splice(this.order.items.indexOf(item), 1)
        }

        if (itemId !== null) {
          this.order.items.push({
            marketing_pack_item_id: itemId,
            delivery_address_id: null,
            data: null
          })
        }
      }
    },
    salesParticularsPackItem () {
      return find(this.pack.items, (item) => item.internal_type_id === 3)
    },
    salesParticularsOrderItem () {
      return find(this.order.items, (item) => item.marketing_pack_item_id === this.salesParticularsPackItem.id)
    },
    additionalWindowCardPackItem () {
      return find(this.pack.items, (item) => item.internal_type_id === 8)
    },
    additionalWindowCardOrderItem () {
      return this.additionalWindowCardPackItem ? find(this.order.items, (item) => item.marketing_pack_item_id === this.additionalWindowCardPackItem.id) : null
    },
    windowCardPackItem () {
      return find(this.pack.items, (item) => item.internal_type_id === 4)
    },
    windowCardOrderItem () {
      return find(this.order.items, (item) => item.marketing_pack_item_id === this.windowCardPackItem.id)
    }
  },
  watch: {
    order: {
      handler () {
        this.$emit('input', this.order)
      },
      deep: true
    },
    'order.delivery_type_id': {
      handler () {
        if (this.salesParticularsOrderItem) {
          this.salesParticularsOrderItem.data.additional_copies_id = null
        }
        if (this.additionalWindowCardOrderItem) {
          this.additionalWindowCardOrderItem.data.print = false
        }
        if (this.windowCardOrderItem) {
          this.windowCardOrderItem.data.print = false
        }
      }
    },
    upgradeFloorplan: {
      handler () {
        let floorplanItem = find(this.order.items, (item) => [this.floorplanIncludedItem.id, this.floorplanUpgradeItem.id].includes(item.marketing_pack_item_id))
        if (floorplanItem) {
          this.order.items.splice(this.order.items.indexOf(floorplanItem), 1)
        }

        let priceData = null
        if (this.upgradeFloorplan && this.propertySizeOrderItem) {
          priceData = {
            id: this.propertySizeOrderItem.data.id
          }
        }

        this.order.items.push({
          marketing_pack_item_id: this.upgradeFloorplan ? this.floorplanUpgradeItem.id : this.floorplanIncludedItem.id,
          delivery_address_id: null,
          data: priceData
        })
      }
    },
    'propertySizeOrderItem.data.id': {
      handler () {
        if (this.upgradeFloorplan) {
          let floorplanItem = find(this.order.items, (item) => [this.floorplanIncludedItem.id, this.floorplanUpgradeItem.id].includes(item.marketing_pack_item_id))
          floorplanItem.data = {
            id: this.propertySizeOrderItem.data.id
          }
        }
      }
    }
  }
}
</script>
